module.exports = __webpack_public_path__ + "img/Check 2.d47cbee3.svg";